/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, themeStyleHelper, disable } from 'utils/styles/style_helpers';


/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// ICON : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
const iconSpaceSize = 7;
export default theme => ({
	icon: {
		// ----- space ----- //
		'&.space': {
			'&-left': {
				marginLeft: pxToEm(iconSpaceSize)
			},
			'&-right': {
				marginRight: pxToEm(iconSpaceSize)
			},
			'&-around': {
				marginLeft: pxToEm(iconSpaceSize),
				marginRight: pxToEm(iconSpaceSize)
			}
		},

		// ----- colors ----- //
		extend: themeStyleHelper(theme, 'color', (theme, uniqueColor) => {
			return {
				'& i': {
					color:  uniqueColor ? theme.color[uniqueColor].medium.swatch : 'initial',
				}
			}
		}),
	}
});